import React, { FC } from "react";
import { ThemeProvider } from "styled-components";
import {
  fanduelColorTokens,
  tvgColorTokens
} from "../../src/theming/themes/tokens";
import { HeadingSizes } from "./types";
import {
  breakpoints,
  radii,
  buttons,
  iconButtons
} from "../../src/theming/themes/common";

import {
  colors,
  elevations,
  space,
  iconSizes,
  fonts,
  fontSizes,
  lineHeights,
  lineHeightsShorter,
  lineHeightsTaller,
  fontWeights
} from "./tokens";

interface TVGThemeProviderProps {
  children: React.ReactNode;
  isFanduelTheme?: boolean;
}

const headingSizes: HeadingSizes = {
  h1: { fontSize: fontSizes["3xl"], lineHeight: lineHeights["3xl"] },
  h2: { fontSize: fontSizes.l, lineHeight: lineHeights.l },
  h3: { fontSize: fontSizes.m, lineHeight: lineHeights.m }
};

const TVG_THEME = {
  name: "tvg",
  colors,
  elevations,
  space,
  iconSizes,
  colorTokens: tvgColorTokens,
  fonts,
  fontSizes,
  lineHeights,
  lineHeightsShorter,
  lineHeightsTaller,
  fontWeights,
  headingSizes,
  radii,
  breakpoints,
  buttons,
  iconButtons
};

const TVGThemeProvider: FC<TVGThemeProviderProps> = ({
  children,
  isFanduelTheme
}) => {
  const colorTokens = isFanduelTheme ? fanduelColorTokens : tvgColorTokens;

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ThemeProvider theme={{ ...TVG_THEME, colorTokens } as unknown as any}>
      {children}
    </ThemeProvider>
  );
};

export { TVG_THEME, TVGThemeProvider, iconSizes };
